import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M.567 8.348A12 12 0 0 0 0 12c0 1.273.199 2.5.567 3.652L12 16.174l11.433-.522C23.801 14.5 24 13.273 24 12s-.2-2.5-.567-3.652L12 7.826z\"></path><path fill=\"#000\" d=\"M24 12c0-.711-.062-1.409-.181-2.086H.18a12 12 0 0 0 0 4.174H23.82q.18-1.019.181-2.087\"></path><path fill=\"#338AF3\" d=\"M12 24c5.354 0 9.888-3.507 11.433-8.348H.566C2.112 20.493 6.646 23.999 12 24M12 0C6.646 0 2.112 3.505.566 8.346h22.867C21.888 3.506 17.353-.001 12-.001\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }